/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WeeklyReportsRow,
    WeeklyReportsRowFromJSON,
    WeeklyReportsRowFromJSONTyped,
    WeeklyReportsRowToJSON,
} from './';

/**
 * 週次リポートリスト
 * @export
 * @interface WeeklyReportsList
 */
export interface WeeklyReportsList {
    /**
     * 
     * @type {Array<WeeklyReportsRow>}
     * @memberof WeeklyReportsList
     */
    reports?: Array<WeeklyReportsRow>;
}

export function WeeklyReportsListFromJSON(json: any): WeeklyReportsList {
    return WeeklyReportsListFromJSONTyped(json, false);
}

export function WeeklyReportsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyReportsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reports': !exists(json, 'reports') ? undefined : ((json['reports'] as Array<any>).map(WeeklyReportsRowFromJSON)),
    };
}

export function WeeklyReportsListToJSON(value?: WeeklyReportsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reports': value.reports === undefined ? undefined : ((value.reports as Array<any>).map(WeeklyReportsRowToJSON)),
    };
}


